<ng-container *ngIf="cardInfo() as cardInfo">
  <mat-card *ngIf="cardInfo.isReady">
    <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar *ngIf="cardInfo.isUpdatedRecordChange">
        <glxy-avatar [width]="AVATAR_WIDTH" icon="business" backgroundColor="white" textColor="#9E9E9E"></glxy-avatar>
      </div>
      <div matCardAvatar *ngIf="!cardInfo.isUpdatedRecordChange"></div>
      <mat-card-title>
        <span class="title">{{ cardInfo.headerText }}</span>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.effectiveDate !== null" class="effective-date">
          {{ cardInfo.effectiveDate | date : dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 18).toString() + 'px'">
      <span class="content">{{ cardInfo.contentText }}</span>
    </mat-card-content>
  </mat-card>
</ng-container>
